import React from 'react';
import { Button } from 'antd';
import { ReloadOutlined, CloseOutlined } from '@ant-design/icons';
import useAppUpdateCheck from '../../hooks/useAppUpdateCheck';

/** Mount once near the app root so the banner can appear on every route. */
const AppUpdateWatcher = () => {
  const { updateAvailable, dismissUpdate, reloadWithUpdate } = useAppUpdateCheck();

  if (!updateAvailable) return null;

  return (
    <>
      <div className="app-update-banner" role="status">
        <div className="app-update-banner__content">
          <span className="app-update-banner__text">
            Dostupna je nova verzija. Osvježite stranicu da učitate najnovije izmjene.
          </span>
          <div className="app-update-banner__actions">
            <Button
              type="primary"
              size="small"
              icon={<ReloadOutlined />}
              onClick={reloadWithUpdate}
            >
              Osvježi
            </Button>
            <button
              type="button"
              className="app-update-banner__dismiss"
              aria-label="Zatvori"
              onClick={dismissUpdate}
            >
              <CloseOutlined />
            </button>
          </div>
        </div>
      </div>
      <div className="app-update-banner-spacer" aria-hidden="true" />
    </>
  );
};

export default AppUpdateWatcher;
